import { GetterTree } from "vuex";
import { RootState } from "../types";
import { JobState } from "./types";
export const getters: GetterTree<JobState, RootState> = {};
